module.exports = __webpack_public_path__ + "static/media/socis-antic.708ead14.jpg";